import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.sort.js";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { Emitter, Event } from '../../../base/common/event.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { IMenuService, isIMenuItem, MenuItemAction, MenuRegistry, SubmenuItemAction } from './actions.js';
import { ICommandService } from '../../commands/common/commands.js';
import { IContextKeyService } from '../../contextkey/common/contextkey.js';

var MenuService = /*#__PURE__*/function () {
  function MenuService(_commandService) {
    _classCallCheck(this, MenuService);

    this._commandService = _commandService; //
  }

  _createClass(MenuService, [{
    key: "createMenu",
    value: function createMenu(id, contextKeyService) {
      return new Menu(id, this._commandService, contextKeyService, this);
    }
  }]);

  return MenuService;
}();

MenuService = __decorate([__param(0, ICommandService)], MenuService);
export { MenuService };

var Menu = /*#__PURE__*/function () {
  function Menu(_id, _commandService, _contextKeyService, _menuService) {
    var _this = this;

    _classCallCheck(this, Menu);

    this._id = _id;
    this._commandService = _commandService;
    this._contextKeyService = _contextKeyService;
    this._menuService = _menuService;
    this._onDidChange = new Emitter();
    this._dispoables = new DisposableStore();
    this._menuGroups = [];
    this._contextKeys = new Set();

    this._build(); // rebuild this menu whenever the menu registry reports an
    // event for this MenuId


    this._dispoables.add(Event.debounce(Event.filter(MenuRegistry.onDidChangeMenu, function (set) {
      return set.has(_this._id);
    }), function () {}, 50)(this._build, this)); // when context keys change we need to check if the menu also
    // has changed


    this._dispoables.add(Event.debounce(this._contextKeyService.onDidChangeContext, function (last, event) {
      return last || event.affectsSome(_this._contextKeys);
    }, 50)(function (e) {
      return e && _this._onDidChange.fire(undefined);
    }, this));
  }

  _createClass(Menu, [{
    key: "dispose",
    value: function dispose() {
      this._dispoables.dispose();

      this._onDidChange.dispose();
    }
  }, {
    key: "_build",
    value: function _build() {
      // reset
      this._menuGroups.length = 0;

      this._contextKeys.clear();

      var menuItems = MenuRegistry.getMenuItems(this._id);
      var group;
      menuItems.sort(Menu._compareMenuItems);

      var _iterator = _createForOfIteratorHelper(menuItems),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          // group by groupId
          var groupName = item.group || '';

          if (!group || group[0] !== groupName) {
            group = [groupName, []];

            this._menuGroups.push(group);
          }

          group[1].push(item); // keep keys for eventing

          Menu._fillInKbExprKeys(item.when, this._contextKeys); // keep precondition keys for event if applicable


          if (isIMenuItem(item) && item.command.precondition) {
            Menu._fillInKbExprKeys(item.command.precondition, this._contextKeys);
          } // keep toggled keys for event if applicable


          if (isIMenuItem(item) && item.command.toggled) {
            var toggledExpression = item.command.toggled.condition || item.command.toggled;

            Menu._fillInKbExprKeys(toggledExpression, this._contextKeys);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._onDidChange.fire(this);
    }
  }, {
    key: "onDidChange",
    get: function get() {
      return this._onDidChange.event;
    }
  }, {
    key: "getActions",
    value: function getActions(options) {
      var result = [];

      var _iterator2 = _createForOfIteratorHelper(this._menuGroups),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var group = _step2.value;

          var _group = _slicedToArray(group, 2),
              id = _group[0],
              items = _group[1];

          var activeActions = [];

          var _iterator3 = _createForOfIteratorHelper(items),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var item = _step3.value;

              if (this._contextKeyService.contextMatchesRules(item.when)) {
                var action = isIMenuItem(item) ? new MenuItemAction(item.command, item.alt, options, this._contextKeyService, this._commandService) : new SubmenuItemAction(item, this._menuService, this._contextKeyService, options);
                activeActions.push(action);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          if (activeActions.length > 0) {
            result.push([id, activeActions]);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return result;
    }
  }], [{
    key: "_fillInKbExprKeys",
    value: function _fillInKbExprKeys(exp, set) {
      if (exp) {
        var _iterator4 = _createForOfIteratorHelper(exp.keys()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var key = _step4.value;
            set.add(key);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "_compareMenuItems",
    value: function _compareMenuItems(a, b) {
      var aGroup = a.group;
      var bGroup = b.group;

      if (aGroup !== bGroup) {
        // Falsy groups come last
        if (!aGroup) {
          return 1;
        } else if (!bGroup) {
          return -1;
        } // 'navigation' group comes first


        if (aGroup === 'navigation') {
          return -1;
        } else if (bGroup === 'navigation') {
          return 1;
        } // lexical sort for groups


        var value = aGroup.localeCompare(bGroup);

        if (value !== 0) {
          return value;
        }
      } // sort on priority - default is 0


      var aPrio = a.order || 0;
      var bPrio = b.order || 0;

      if (aPrio < bPrio) {
        return -1;
      } else if (aPrio > bPrio) {
        return 1;
      } // sort on titles


      return Menu._compareTitles(isIMenuItem(a) ? a.command.title : a.title, isIMenuItem(b) ? b.command.title : b.title);
    }
  }, {
    key: "_compareTitles",
    value: function _compareTitles(a, b) {
      var aStr = typeof a === 'string' ? a : a.value;
      var bStr = typeof b === 'string' ? b : b.value;
      return aStr.localeCompare(bStr);
    }
  }]);

  return Menu;
}();

Menu = __decorate([__param(1, ICommandService), __param(2, IContextKeyService), __param(3, IMenuService)], Menu);